// extracted by mini-css-extract-plugin
module.exports = {"viewContent":"View_viewContent__Kwlda"};